// Canonical Mixpanel event vocabulary for discover-sdk configurators.
// Source of truth: "Mixpanel Event Mapping" sheet (Tahoe Configurator, 2365).
export const AnalyticsIds = {
  // KPIs / lifecycle
  mixpanelStart: 'mixpanelStart',
  sessionEnd: 'sessionEnd',

  // Loading
  modelLoadStart: 'modelLoadStart',
  modelLoadTime: 'modelLoadTime',
  modelLoadEnd: 'modelLoadEnd',
  modelLoadError: 'modelLoadError',

  // Landing
  landingView: 'landingView',
  specDetailsInteract: 'specDetailsInteract',
  specSaveInteract: 'specSaveInteract',
  shareInteract: 'shareInteract',
  languageInteract: 'languageInteract',
  termsInteract: 'termsInteract',
  buildYourRideInteract: 'buildYourRideInteract',

  // Dealer selection
  dealerModalView: 'dealerModalView',
  dealerSelectInteract: 'dealerSelectInteract',
  dealerConfirmInteract: 'dealerConfirmInteract',
  dealerModalClose: 'dealerModalClose',
  changeDealerInteract: 'changeDealerInteract',

  // Configurator shell
  navigationInteract: 'navigationInteract',
  viewToggleInteract: 'viewToggleInteract',
  menuInteract: 'menuInteract',
  backgroundInteract: 'backgroundInteract',
  interactionInteract: 'interactionInteract',
  modelYearInteract: 'modelYearInteract',
  variantInteract: 'variantInteract',
  colorInteract: 'colorInteract',
  wheelInteract: 'wheelInteract',
  categoryInteract: 'categoryInteract',
  interiorInteract: 'interiorInteract',
  featureInteract: 'featureInteract',
  featureAutoplayInteract: 'featureAutoplayInteract',

  // Inventory / matching vehicles
  matchingNudgeShown: 'matchingNudgeShown',
  matchingNudgeInteract: 'matchingNudgeInteract',
  matchingVehiclesInteract: 'matchingVehiclesInteract',
  viewDifferencesInteract: 'viewDifferencesInteract',
  inventoryProceedInteract: 'inventoryProceedInteract',
  inventoryClose: 'inventoryClose',

  // Summary & leads
  summaryItemRemove: 'summaryItemRemove',
  saveBuildInteract: 'saveBuildInteract',
  checkoutInteract: 'checkoutInteract',
  proceedModalView: 'proceedModalView',
  bookingCtaInteract: 'bookingCtaInteract',
  leadFormStart: 'leadFormStart',
  leadFormFieldInteract: 'leadFormFieldInteract',
  leadFormSubmit: 'leadFormSubmit',
  leadFormError: 'leadFormError',
  leadFormClose: 'leadFormClose',
} as const;

export type AnalyticsId = (typeof AnalyticsIds)[keyof typeof AnalyticsIds];
